export enum notificationTypes {
  BADGE = 'Badge',
  ALERT = 'Alert',
}
